import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createModel } from '@kp/js-model';

export class ReduktionAngrenzendeGebaeude extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;

    bauperiode_id: number | null = null;
    reduktion_1_gebaeude: number | null = null;
    reduktion_2_gebaeude: number | null = null;
    reduktion_3_gebaeude: number | null = null;
    bemerkung: string | null = null;

    // view fields
    bauperiode_i18n_key: string | null = null;
    bauperiode_code: number | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'ReduktionAngrenzendeGebaeude';
    }
}

export async function createNewReduktionAngrenzendeGebaeude(): Promise<ReduktionAngrenzendeGebaeude> {
    const model = createModel(ReduktionAngrenzendeGebaeude, {});

    await model.save();
    return model;
}

export class ReduktionAngrenzendeGebaeudeCollection extends BaseCollection<ReduktionAngrenzendeGebaeude> {
    protected modelCls = ReduktionAngrenzendeGebaeude;

    public getModelClassName(): string {
        return 'ReduktionAngrenzendeGebaeude';
    }
}
